import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Skeleton from 'app/components/base/Skeleton'
import Text from 'app/components/base/Text'
import ReportLink from 'app/components/common/ReportLink'

interface ReportListingBlockProps {
  listingId: string
  loading?: boolean
  hideBlock?: boolean
}

const ReportListingBlock: RFC<ReportListingBlockProps> = ({
  listingId,
  loading,
  hideBlock = false
}) => {
  const link = (chunk: React.ReactNode[]): React.ReactNode => (
    <ReportLink
      id={listingId}
      sx={{
        fontWeight: 500,
        color: 'primary.main',
        ...Platform.select({
          web: {
            display: 'inline-flex'
          }
        })
      }}
    >
      {chunk}
    </ReportLink>
  )

  return (
    <Skeleton loading={loading} width="80%" sx={{ mt: { xs: 2, md: 3 } }}>
      {!hideBlock && (
        <Text
          component="div"
          variant="body2"
          sx={{ color: 'text.third', mt: { xs: 2, md: 3 } }}
        >
          <FormattedMessage
            defaultMessage="Against the sale or site rules? <link>Report this item</link>"
            values={{ link }}
          />
        </Text>
      )}
    </Skeleton>
  )
}

export default ReportListingBlock
